import {axiosClient} from "./httpClient";
import {errorToast, successToast, warningToast} from "./Util";
import {DONE, QA} from "./Constants";


function reportError(err) {
    console.error(err);
    errorToast("Something went wrong, please try again");
}

export function decideTimeline(revisions) {
    return revisions > 0 ? 24 : 48;
}

export function addRevision(cardId, currentStatus, callback) {
    axiosClient.post(`/api/card/${cardId}/revision`,
        {card_id: cardId, card_status: currentStatus})
        .then(({data}) => {
            successToast(data?.success || "Card moved to revision successfully");
            callback();
        }).catch(err => reportError(err));
}

export async function updateSorting(cards) {
    if (cards.length > 0) {
        return axiosClient.post('/api/cards/updateSort', {cards})
            .then(({data}) => {
                successToast(data?.success || "Information updated successfully");
            }).catch(err => reportError(err));
    }
}

export function moveCard(cardId, target, source, callback) {
    axiosClient.post(`/api/card/${cardId}/move`, {
        card_id: cardId, card_status: source, newStatus: target
    }).then(({data}) => {
        successToast(data?.success || "Card moved successfully");
        if(callback) {
            callback();
        }
    }).catch(err => reportError(err));
}

export function moveCardSubStatus(
    cardId,
    target,
    source,
    callback,
    {
        targetColumnType,
        sourceColumnType,
        additionalData = {},
        selectedFile
    } = {}
) {
    const calledBy = sourceColumnType || source;

    let tempObj = {};

    if (additionalData.done_link && additionalData.done_link.url !== "") {
        tempObj.done_link = additionalData.done_link;
    }

    if (additionalData.doneLinkUrlArray && additionalData.doneLinkUrlArray.length > 0) {
        additionalData.doneLinkUrlArray = additionalData.doneLinkUrlArray.filter(d => d.url !== "");
        tempObj.done_link = [additionalData.done_link, ...additionalData.doneLinkUrlArray];
    }

    axiosClient.post(`/api/card/${cardId}/moveCardSub`, {
        card_id: cardId,
        status: target,
        from: source,
        srtFile: selectedFile,
        ...tempObj,
        calledBy
    }).then(response => {
        if(response.status !== 204) {
            successToast(response.data?.message || "Card moved successfully");
        } else {
            warningToast(response.data?.message || "Not allowed");
        }
        if (callback) callback();
    }).catch(err => {
        if ( err?.response?.data?.message && err?.response?.data?.message !== "") {
            errorToast(err.response.data.message);
        } else {
            reportError(err);
        }
    });
}

export function addCardTimeline(cardId, currentStatus, timeline, callback) {
    axiosClient.post(`/api/card/${cardId}/timeline`,
    {card_id: cardId, timeline, card_status: currentStatus})
        .then(({data}) => {
            successToast(data?.success || "Card moved successfully");
            callback();
        }).catch(err => reportError(err));
}

export function markAsDone(cardId, cardStatus, doneLink="", callback, content_id = "", doneLinkUrlArray=[]) {
    if(doneLinkUrlArray && doneLinkUrlArray.length > 0) {
        doneLink = [doneLink,...doneLinkUrlArray];
    }
    axiosClient.post(`/api/card/${cardId}/done`, {
        card_id: cardId, card_status: cardStatus, newStatus: DONE, done_link: doneLink,content_id
    }).then(({data}) => {
        successToast(data?.success || "Card moved successfully");
        if(callback)
        {
            callback();
        }
    }).catch(err => {
        // reportError(err);
        err?.response?.data?.message ? errorToast(err.response.data.message) : reportError(err);
    });
}


export function moveToQa(cardId, cardStatus, doneLink="", callback, content_id = "", doneLinkUrlArray=[]) {
    if(doneLinkUrlArray && doneLinkUrlArray.length > 0) {
        doneLink = [doneLink, ...doneLinkUrlArray];
    }
    axiosClient.post(`/api/card/${cardId}/moveToQa`, {
        card_id: cardId, card_status: cardStatus, newStatus: QA, done_video_link: doneLink, content_id
    }).then(({data}) => {
        successToast(data?.success || "Card moved successfully");
        if(callback)
        {
            callback();
        }
    }).catch(err => reportError(err));
}

export function moveYtHelperCardInProgress(cardId, target, source,refresh)
{
    axiosClient.post(`/api/ythelper/card/${cardId}/move`,{
        card_id: cardId, target,source
    }).then(({data})=>{
        successToast(data?.success || "Card moved successfully");
        if(refresh)
        {
            refresh();
        }
        // setTimeout(()=>{refresh()},2000);
    }).catch(err=> reportError(err));
}

export function moveYtHelperCardInDone(cardId, target, source,thumbnailsLink,videoDescription,snippetLink,unlistedLink,refresh)
{
    axiosClient.post(`/api/ythelper/card/${cardId}/done`,{
        card_id: cardId, target,source,thumbnailsLink,videoDescription,snippetLink,unlistedLink
    }).then(({data})=>{
        successToast(data?.success || "Card moved successfully");
        if(refresh)
        {
            refresh();
        }
        // setTimeout(()=>{refresh()},2000);
    }).catch(err=> reportError(err));
}

export function moveYtCard(cardId, target, source, callback) {
    axiosClient.post(`/api/ythelper/card/${cardId}/internalMove`, {
        card_id: cardId, card_status: source, newStatus: target
    }).then(({data}) => {
        successToast(data?.success || "Card moved successfully");
        if(callback) {
            // callback();
        }
    }).catch(err => reportError(err));
}

export function handleCardMarkAsCompleted(data) {
    if (!data?.cardId || !data?.cardStatus) {
        errorToast("Invalid card data");
        return Promise.resolve(false);
    }
    const cardSection = data.cardStatus === DONE ? "done" : (data.cardStatus === "repurposeDone" || data.cardStatus === "repurposeEditing") ? "repurpose" : null;
    if (!cardSection) {
        errorToast("Invalid card status");
        return Promise.resolve(false);
    }
    return axiosClient.post(`/api/card/${data.cardId}/markComplete`, {
        card_id: data.cardId,
        status: 1,
        cardSection,
        buttonText: "Mark As Done",
        calledBy: cardSection === "done" ? "normalDone" : "repurposeDone",
    }).then(({data: res}) => {
        successToast(res?.success || "Card marked completed!");
        return true;
    }).catch(err => {
        errorToast(err?.response?.data?.message || "Something went wrong, please try again");
        console.error(err);
        return false;
    });
}
